import React, { FC } from "react";
import styled from "styled-components";
import { Entry } from "contentful";
import contentfulComponentLoop from "../lib/contentfulComponentLoop";

interface ContentGridProps extends Entry {
  id: string,
  fields: {
    components: any
  }
}

const GridContainer = styled.div<{ $count: number; }>`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(1, 1fr);
  
  @media (min-width: 768px) {
    ${({ $count }) => $count == 2 && `
      grid-template-columns: repeat(2, 1fr);
    `}

    ${({ $count }) => $count == 3 && `
      grid-template-areas:
        "one one two two"
        "one one three three";
    `}

    ${({ $count }) => $count == 4 && `
      grid-template-areas:
        "one one two two"
        "one one three four";
    `}

    ${({ $count }) => $count == 5 && `
      grid-template-areas:
        "one one two three"
        "one one four five";
    `}

    ${({ $count }) => $count == 6 && `
      grid-template-areas:
        "one one three four"
        "two two five six";
    `}

    ${({ $count }) => $count == 7 && `
      grid-template-areas:
        "one one four five"
        "two three six seven";
    `}

    ${({ $count }) => $count == 8 && `
      grid-template-columns: repeat(4, 1fr);
    `}

    ${({ $count }) => ($count > 2 && $count < 8) && `
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: 50%;

      > div { width: 100%; }

      > div:nth-of-type(1) { grid-area: one; }
      > div:nth-of-type(2) { grid-area: two; }
      > div:nth-of-type(3) { grid-area: three; }
      > div:nth-of-type(4) { grid-area: four; }
      > div:nth-of-type(5) { grid-area: five; }
      > div:nth-of-type(6) { grid-area: six; }
      > div:nth-of-type(7) { grid-area: seven; }
      > div:nth-of-type(8) { grid-area: eight; }
    `}
  }

  // Currently, MediaTile is the only allowed child.
  // This might need adjusted if that changes.
  > div:hover {
    img {
      transform: scale(1.1);
    }
  }
`;

const ContentGrid: FC<ContentGridProps> = ({ id, fields: { components }}) => (
  <GridContainer data-component-id={id} $count={components?.length}>
    {contentfulComponentLoop(components, { parentComponentId: id })}
  </GridContainer>
);

export default ContentGrid;